type ArrangementEndpointError = { statusCode?: number } | null | undefined;

export type ArrangementEndpointErrors = {
  configError: ArrangementEndpointError;
  pricingError: ArrangementEndpointError;
  catalogError: ArrangementEndpointError;
  stateError: ArrangementEndpointError;
};

// The four errors this module takes come from the case's own locked routes. A
// minimal-access contact is answered 404 there so the case's existence is not
// disclosed, and 403 from older deployments; both mean access denied.
function isAccessDeniedArrangementEndpointError(
  error: ArrangementEndpointError,
): boolean {
  return error?.statusCode === 403 || error?.statusCode === 404;
}

export function hasArrangementAccessDeniedError(
  errors: ArrangementEndpointErrors,
): boolean {
  return [
    errors.configError,
    errors.pricingError,
    errors.catalogError,
    errors.stateError,
  ].some(isAccessDeniedArrangementEndpointError);
}
